module.exports = __webpack_public_path__ + "static/media/landmark-alt.4b3eda18.svg";